{
  "loading": "A carregar...",
  "placeholder": "Selecionar…"
}
